import React from "react";
import _ from "lodash";
import Proptypes from "prop-types";

// objects
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const UUID = /^[0-9]{8}-[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{12}$/i ;

const PASSWORD = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!#$%^&*@])(?=.{8,})/ ;

const MOBILE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/; 

const NUMBER = /^[0-9]\d*$/;

const POSITIVE_FLOAT = /^\d+(\.\d{1,2})?$/;

const SECRET = /^[A-Z0-9]*$/;

const required = value => value || value === 0 ? undefined : "Required";

const secret = value => SECRET.test(value) ?  (value.length == 16 ? undefined : "secret is invalid") : "Secret is invalid"

const json = (value) => {
                            try {
                                if (!value){
                                    return undefined;
                                }
                                let js = JSON.parse(value);

                                if (js && typeof js === "object") {
                                    return undefined;
                                } else {
                                    return "Must be json";
                                }
                            } catch (e) {
                                return "Must be json";
                            }
                        };

const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;

const number = (value) => NUMBER.test(value) ? undefined : "Must be a positive Integer";

const empty_or_number = (value) => value === "" || value === undefined  || value === null || NUMBER.test(value) ? undefined : "Must be a positive Integer";

const positive_float = (value) => POSITIVE_FLOAT.test(value) ? undefined : "Must be a positive Number";

const minValue = min => value => value && value < min ? `Must be at least ${min}` : undefined;

const maxValue = max => value => value && value > max ? `Must be at least ${max}` : undefined;

const email = (value) => EMAIL_REGEX.test(value) ? undefined : "Email is invalid";

const uuid = (value) => UUID.test(value) ? undefined : "UUID Id is Invalid";

const mobile = (value) => MOBILE.test(value) ? undefined : "Mobile Number is Invalid";

const password =(value) => PASSWORD.test(value) ? undefined : "Passwords must be at least 8 characters long and contain 1 upper case, 1 lower case, 1 number, and 1 special character.";

const mustMatch = (field) => (value, allValues) => { 
    const data = allValues;
    return !_.isEmpty(data) && data[field] === value ? undefined : "Fields Must Match";
};

const noOldPassword = (field) => (value, allValues) => { 
    const data = allValues;
    return !_.isEmpty(data) && data[field] === value ?  "New password cannot be the same as the old password" : undefined;
};

const errorToFields = (data = {}) => {
    const errors = {};
    if (data) {
        _.forEach(data.errors, (error) => {
            const key = error.source.pointer.replace("/data/attributes/", "");
            const fieldName = _.upperFirst(key.replace("_", " "));
            errors[key] = `${fieldName} ${error.detail}`;
        });
    }

    return errors;
};

class renderPass extends React.Component{
    constructor(props) {
        super(props)
        this.state = {hidden: true};
        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden });
    }

    render() {
        return (
            <div className="relative">
                <div className="password-field">
                    <input {...this.props.input} placeholder={this.props.placeholder}
                           type={this.state.hidden ? 'password' : 'text'}
                           className={this.props.validationError || (this.props.meta.touched && this.props.meta.error) ? "form-control validationError" : "form-control"}/>
                    <i onMouseDown={() => this.setState({ hidden: !this.state.hidden })}
                       className={this.state.hidden ? "fa fa-solid fa-eye-slash" : "fa fa-solid fa-eye" }/>
                </div>
                <div>
                    {this.props.meta.touched && ((this.props.meta.error && <span className="error_txt">{this.props.meta.error}</span>) || (this.props.meta.warning &&
                        <span className="error_txt">{this.props.meta.warning}</span>))}
                </div>
                {this.props.validationError && <div>
                    {(this.props.validationError && <span className="error_txt">{this.props.validationError}</span>)}
                </div>}
            </div>
        );
    }
};

class renderPassTextArea extends React.Component{
    constructor(props) {
        super(props)
        this.state = {hidden: true};
        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden });
    }

    render() {
        let className = this.props.validationError || (this.props.meta.touched && this.props.meta.error) ? "form-control validationError" : "form-control"
        if (this.state.hidden){
            className += ' input-blur'
        }

        return (
            <div className="relative">
                <textarea {...this.props.input} placeholder={this.props.placeholder}
                       className={className}
                       style={{'minHeight':'200px'}}
                />
                <i onMouseDown={() => this.setState({ hidden: !this.state.hidden })}
                   className={this.state.hidden ? "fa fa-solid fa-eye-slash" : "fa fa-solid fa-eye" }/>
                <div>
                    {this.props.meta.touched && ((this.props.meta.error && <span className="error_txt">{this.props.meta.error}</span>) || (this.props.meta.warning &&
                        <span className="error_txt">{this.props.meta.warning}</span>))}
                </div>
                {this.props.validationError && <div>
                    {(this.props.validationError && <span className="error_txt">{this.props.validationError}</span>)}
                </div>}
            </div>
        );
    }
};



const renderField = ({ input, type, disabled, autoFocus, placeholder,validationError, meta: { touched, error, warning } }) => {
    autoFocus = autoFocus || false
    return(
        <div className="relative">
            <div> 
                <input autoFocus={autoFocus} {...input} placeholder={placeholder} type={type} disabled={disabled} className={validationError || (touched && error) ? "form-control validationError" : "form-control"}/>
            </div>
            <div>
                {touched && ((error && <span className="error_txt">{error}</span>) || (warning && <span className="error_txt">{warning}</span>))}
            </div>
            {validationError && <div>
                {(validationError && <span className="error_txt">{validationError}</span>)}
            </div>}
        </div>
    );
};

const renderSelectField = ({ input, disabled, autoFocus, placeholder,validationError, meta: { touched, error, warning }, children }) => {
    autoFocus = autoFocus || false
    return(
        <div className="relative">
            <div> 
            <select {...input} autoFocus={autoFocus} placeholder={placeholder} disabled={disabled} className={validationError || (touched && error) ? "form-control validationError" : "form-control"}>
                {children}
            </select>
            </div>
            <div>
                {touched && ((error && <span className="error_txt">{error}</span>) || (warning && <span className="error_txt">{warning}</span>))}
            </div>
            {validationError && <div>
                {(validationError && <span className="error_txt">{validationError}</span>)}
            </div>}
        </div>
    );
};

const renderTextArea = ({ input, type, disabled, placeholder,validationError, meta: { touched, error, warning } }) => {
    return(
        <div className="relative">
            <div>
                <textarea style={{'minHeight':'200px'}} {...input} placeholder={placeholder} type={type} disabled={disabled}  className={validationError || (touched && error) ? "form-control validationError" : "form-control"}/>
            </div>
            <div>
                {touched && ((error && <span className="error_txt">{error}</span>) || (warning && <span className="error_txt">{warning}</span>))}
            </div>
            {validationError && <div>
                {(validationError && <span className="error_txt">{validationError}</span>)}
            </div>}
        </div>
    );
};

const renderCheckbox = ({ input, checked, validationError, meta: { touched, error, warning } }) => {
    return(
        <span>
            <input {...input} 
                type="checkbox"  
                defaultChecked={checked == true ? checked: false} 
            />

            <div>
                {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
            </div>
            {validationError && <div>
                {(validationError && <span>{validationError}</span>)}
            </div>}
        </span>
    );
};

renderPass.propTypes = {
    input: Proptypes.object,
    type: Proptypes.string,
    placeholder: Proptypes.string,
    validationError: Proptypes.object,
    meta: Proptypes.object
};

renderPassTextArea.propTypes = {
    input: Proptypes.object,
    type: Proptypes.string,
    placeholder: Proptypes.string,
    validationError: Proptypes.object,
    meta: Proptypes.object
};

renderSelectField.propTypes = {
    input: Proptypes.object,
    placeholder: Proptypes.string,
    autoFocus: Proptypes.bool,
    validationError: Proptypes.object,
    meta: Proptypes.object
};

renderField.propTypes = {
    input: Proptypes.object,
    type: Proptypes.string,
    placeholder: Proptypes.string,
    autoFocus: Proptypes.bool,
    validationError: Proptypes.object,
    meta: Proptypes.object
};


renderCheckbox.propTypes = {
    input: Proptypes.object,
    checked: Proptypes.bool,
    validationError: Proptypes.object,
    meta: Proptypes.object
};

renderTextArea.propTypes = {
    input: Proptypes.object,
    type: Proptypes.string,
    placeholder: Proptypes.string,
    validationError: Proptypes.object,
    meta: Proptypes.object
};



export {
    errorToFields,
    maxValue,
    maxLength,
    minValue,
    number,
    empty_or_number,
    positive_float,
    required,
    json,
    secret,
    email,
    mobile,
    mustMatch,
    renderPass,
    renderPassTextArea,
    renderField,
    renderSelectField,
    renderCheckbox,
    renderTextArea,
    password,
    uuid,
    noOldPassword
};